/**
 * Descreve, em texto curto, o que acabou de ser gravado por um diálogo de card.
 *
 * Serve às notas que o atalho "+" cria na consulta (salvia-781): sem isto a
 * nota diria apenas "informação registrada", que não ajuda quem lê o
 * atendimento depois. O diálogo é o único que sabe o que gravou, então é ele
 * quem entrega os dados aqui.
 *
 * Devolve UMA ETIQUETA POR ITEM, e não uma linha só: escolher três alergias de
 * uma vez tem que virar três notas, uma para cada, do mesmo jeito que ficaria
 * se tivessem sido lançadas separadamente.
 *
 * Os cards guardam formas diferentes — uns salvam lista de itens escolhidos,
 * outros um registro único com medições. Por isso a leitura é por tentativa:
 * procura-se um campo de nome conhecido e, não havendo, um campo de valor.
 * Item que não casa com nada é descartado; se sobrar nada, a nota cai no texto
 * genérico — nunca se inventa conteúdo nem se quebra o salvamento.
 */

/** Campos que costumam carregar o nome do que foi registrado. */
const CAMPOS_NOME = [
  "name",
  "description",
  "allergen",
  "symptom",
  "restriction",
  "treatment",
  "goal",
  "medication",
  "supplement",
  "content",
  "title",
];

/** Campos de medição, com o rótulo que aparece na nota. */
const CAMPOS_VALOR = [
  ["liters_per_day", (v) => `${String(v).replace(".", ",")} L/dia`],
  ["quality", (v) => `qualidade ${v}`],
  ["frequency", (v) => `frequência ${v}`],
  ["menstrual_status", (v) => `ciclo ${v}`],
  ["weight", (v) => `${String(v).replace(".", ",")} kg`],
  ["modality", (v) => String(v)],
];

function texto(valor) {
  return typeof valor === "string" ? valor.trim() : "";
}

/** Etiqueta de um item isolado. Devolve "" quando não dá para nomear. */
export function rotuloDoItem(item) {
  if (typeof item === "string") return item.trim();
  if (!item || typeof item !== "object") return "";

  for (const campo of CAMPOS_NOME) {
    const t = texto(item[campo]);
    if (t) return t;
  }

  for (const [campo, formatar] of CAMPOS_VALOR) {
    const v = item[campo];
    if (v !== null && v !== undefined && v !== "") return formatar(v);
  }

  return "";
}

/**
 * Uma etiqueta por item gravado, na ordem em que foram escolhidos.
 *
 * @param {Array|Object|string} dados o que o diálogo gravou
 * @returns {string[]} etiquetas legíveis; vazio quando não há o que dizer
 */
export function rotulosDoRegistro(dados) {
  const itens = Array.isArray(dados) ? dados : [dados];

  return itens.map(rotuloDoItem).filter(Boolean);
}
